import {css} from '@emotion/css';
import {colours, fonts, spacing} from '@fo/shared/styles/variables';
import {negative} from '@fo/shared/styles/mixins';

const signContainerWidth = 3;

export default {
  container: (isDisabled?: boolean): string => css`
    label: percentage;
    position: relative;
    padding-left: ${signContainerWidth + 0.4}rem; // stylelint-disable-line sh-waqar/declaration-use-variable
    &::before {
      position: absolute;
      display: block;
      width: ${signContainerWidth}rem;
      height: 4rem;
      margin-top: ${spacing.XXXS};
      margin-left: ${negative(
        `${signContainerWidth + 0.4}rem`
      )}; // stylelint-disable-line sh-waqar/declaration-use-variable
      background-color: ${colours.background.OFF_WHITE};
      border: 1px solid ${colours.border.LIGHT_GRAY};
      content: '';
    }
    &::after {
      position: absolute;
      top: 50%;
      left: ${signContainerWidth / 2}rem;
      padding-top: 0.5rem; // stylelint-disable-next-line sh-waqar/declaration-use-variable
      color: ${colours.font.ASSISTIVE};
      font-size: 2.2rem;
      font-weight: ${fonts.weight.SEMI_BOLD};
      text-align: center;
      transform: translate(-50%, -50%);
      content: '%';
    }
    ${isDisabled
      ? `
      &::before,
      &::after {
        color: ${colours.font.DISABLED};
      }
    `
      : ''}
  `,
};
